import { Action, Types } from "./userLeaves.actions"

export type UserLeave = {
  code: string
  hours: number
  title: string
}

export type UserLeavesState = {
  params: { year: string; uid: string }
  data: UserLeave[]
  loading: boolean
  errors: object
}

const initialState: UserLeavesState = {
  params: { year: "", uid: "" },
  data: [],
  loading: false,
  errors: {},
}

export default (state = initialState, action: Action): UserLeavesState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        params: action.payload.params,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data!,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
